import { render, staticRenderFns } from "./chooseadudition.vue?vue&type=template&id=190c700e&scoped=true"
import script from "./chooseadudition.vue?vue&type=script&lang=js"
export * from "./chooseadudition.vue?vue&type=script&lang=js"
import style0 from "./chooseadudition.vue?vue&type=style&index=0&id=190c700e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190c700e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('190c700e')) {
      api.createRecord('190c700e', component.options)
    } else {
      api.reload('190c700e', component.options)
    }
    module.hot.accept("./chooseadudition.vue?vue&type=template&id=190c700e&scoped=true", function () {
      api.rerender('190c700e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/frontbusiness/chooseadudition.vue"
export default component.exports